import { useEffect, FC } from 'react'

import {
  Button,
  Form,
  Grid,
  Input,
  Picker,
  RadioGroup,
  Row,
  Span
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

interface IFilterAnalyzeCre {
  control: any
  errors: any
  onSubmit: () => void
  areDatesValid: () => boolean
  handleReset: () => void
  // blockPesquisar: boolean
}
export const FilterAnalyzeCre: FC<IFilterAnalyzeCre> = ({
  control,
  onSubmit,
  handleReset,
  errors,
  areDatesValid
}) => {
  const radioGroupOptions = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false }
  ]

  const hasError = Object.keys(errors).length > 0

  return (
    <Form onSubmit={onSubmit}>
      <Grid
        gridCols="1fr 2fr 1fr 1fr 1.5fr 1.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          label="Contrato"
          placeholder="Nº"
          formValue="Contrato"
          control={control}
          maxLength={100}
        />
        <Input
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue="NmFornecedor"
          control={control}
          maxLength={100}
        />
        <Picker
          errors={errors}
          type="monthAndYear"
          defaultValue={null}
          label="Mês / Ano Verificação"
          placeholder="mm/aaaa"
          control={control}
          formValue="MesAnoVerificacao"
        />
        <Input
          label="CRE"
          placeholder="Nº"
          formValue="CRE"
          control={control}
          maxLength={100}
        />
        <RadioGroup
          label="Bloqueio Pagamento"
          control={control}
          formValue="BloqPagamento"
          row
          listOptions={radioGroupOptions}
        />
      </Grid>
      <Row alignItems="center" justifyContent="space-between">
        <Row alignItems="center">
          <Row alignItems="center" marginRight={SPACING.spacing15}>
            <Picker
              defaultValue={null}
              label="Data Liberação"
              placeholder="dd/mm/aaaa"
              control={control}
              errors={errors}
              formValue="DataInicioLiberacao"
            />
            <Span
              text="à"
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing15}
              marginTop={SPACING.spacing30}
            />
            <Picker
              defaultValue={null}
              placeholder="dd/mm/aaaa"
              control={control}
              errors={errors}
              formValue="DataFimLiberacao"
            />
          </Row>

          <Row alignItems="center" marginRight={SPACING.spacing20}>
            <Picker
              defaultValue={null}
              label="Data Retorno"
              placeholder="dd/mm/aaaa"
              control={control}
              errors={errors}
              formValue="DataInicioRetorno"
            />
            <Span
              text="à"
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing15}
              marginTop={SPACING.spacing30}
            />
            <Picker
              defaultValue={null}
              placeholder="dd/mm/aaaa"
              control={control}
              errors={errors}
              formValue="DataFimRetorno"
            />
          </Row>
          <RadioGroup
            label="Bloqueio CRE"
            control={control}
            formValue="BloqCre"
            row
            listOptions={radioGroupOptions}
          />
        </Row>
        <Row
          alignItems="center"
          marginTop={SPACING.spacing15}
          marginBottom={SPACING.spacing15}
        >
          <Button
            text="Limpar"
            variantButton="text"
            marginRight={SPACING.spacing15}
            onClick={handleReset}
          />
          <Button
            disabled={!areDatesValid()}
            text="Pesquisar"
            endIcon={<MagnifyingGlassIcon opacity={hasError ? 0.26 : 1} />}
            type="submit"
          />
        </Row>
      </Row>
    </Form>
  )
}
